import { WorkforceGroup } from '../events.era'
// import { filterTimeline } from './onsite.reselector.filtering'
import { createSelector } from '@ngrx/store'
import { unfilteredFullMultiTimelineReselector } from './onsiteTimeline.reselector'
import { User } from 'globals/store/user.data';
import { DateSchedule, programsStateSelector } from 'src/app/store/programs.era';
import { FilterGroup } from '../filters.era'
import { Asset } from 'globals/store/assets.data'
import { Dictionary } from '@ngrx/entity'
import { fullProgramOrderReselector, programsArray } from './programs.reselector'
import { workforceStateSelector } from '../workforce.era';
import { userStateSelector } from '../user.era';
import { exhibitorStandsStateSelector } from '../exhibitor.stands.era';
import { assetsStateSelector } from '../assets.era';
import { filterTimeline } from 'globals/share/onsite.filtering';
import { convertMultiTimelineToSingleTimeline } from 'globals/functions/onsite.reselector.functions';

const workforceGroups = createSelector(workforceStateSelector, (state) => state.wf_groups);
const user = createSelector(userStateSelector, (state) => state.user);
const stands = createSelector(exhibitorStandsStateSelector, (state) => state.entities);
const assets = createSelector(assetsStateSelector, (state) => state.entities);
const programs = createSelector(programsStateSelector, (state) => state.entities);

export const getMyScheduleFilters = ( you: User, wf_groups: WorkforceGroup[]): FilterGroup => {
  const groupTags = !wf_groups ? [] : wf_groups.filter(g => g.members.includes(you.email)).map(g => g.name)
  const filters: FilterGroup = {
    count: 1 + (!groupTags.length ? 0 : 1),
    tags: [you.email]
  }
  if (groupTags.length) filters.groupTags = groupTags
  return filters
}

export const myScheduleFullMultiTimelineReeselector = createSelector(
  unfilteredFullMultiTimelineReselector,
  user,
  workforceGroups,
  stands,
  programs,
  (fullMultiTimeline: DateSchedule[], you: User, wf_groups: WorkforceGroup[], stands, programs) => {
    // console.log("myScheduleFullMultiTimelineReeselector")
    return filterTimeline(fullMultiTimeline, getMyScheduleFilters(you, wf_groups), true, null, 'mySchedule', stands, programs)
  }
    
)

export const myScheduleFullSingleTimelineReselector = createSelector(
  myScheduleFullMultiTimelineReeselector,
  assets,
  fullProgramOrderReselector,
  (fullMultiTimeline: DateSchedule[], assets: Dictionary<Asset>, fullProgramOrder: string[]) => fullMultiTimeline.map(timeline => convertMultiTimelineToSingleTimeline(timeline, assets, fullProgramOrder))
  
)